/*!
  =========================================================
  * Muse Ant Design Dashboard - v1.0.0
  =========================================================
  * Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
  * Copyright 2021 Creative Tim (https://www.creative-tim.com)
  * Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
  * Coded by Creative Tim
  =========================================================
  * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import {
  Row,
  Col,
  Card,
  Statistic,
  Button,
  List,
  Descriptions,
  Avatar,
  Form,
  Input,
  Divider,
} from "antd";

import { QRCode } from 'react-qrcode-logo';
import { PlusOutlined, ExclamationOutlined } from "@ant-design/icons";
import mastercard from "../assets/images/mastercard-logo.png";
import paypal from "../assets/images/paypal-logo-2.png";
import visa from "../assets/images/visa-logo.png";
import qr_logo from "../assets/images/logo/logo_lidig_2.png";
import React, { Component } from "react";
import { PDFDocument } from "pdf-lib";
const download = require('downloadjs');

class QRCodeGenerator extends Component {
  formRef = React.createRef();
  state = {
    link:"",
  }
  generateQR = (e) => {
    const val = e.target.value;
    this.setState({ link: val });
  }
  downloadQRCode = () => {
    const canvas = document
      .getElementById("qrCode");
      //.querySelector("canvas");

    if (!canvas) {
      console.error("Canvas QR tidak ditemukan");
      return;
    }

    const pngUrl = canvas.toDataURL("image/png");

    const downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "QRCode.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  downloadQRCodeHD = () => {
    const canvas = document
      .getElementById("qrCode");
      //?.querySelector("canvas");

    if (!canvas) {
      console.error("Canvas QR tidak ditemukan");
      return;
    }
    const scale = 3;
    const tempCanvas = document.createElement("canvas");
    tempCanvas.width = canvas.width * scale;
    tempCanvas.height = canvas.height * scale;

    const ctx = tempCanvas.getContext("2d");
    ctx.scale(scale, scale);
    ctx.drawImage(canvas, 0, 0);

    const pngUrl = tempCanvas.toDataURL("image/png");

    const link = document.createElement("a");
    link.href = pngUrl;
    link.download = "QRCode-HD.png";
    link.click();
  };


  render() {
    return (
      <>
        <Row gutter={[24, 0]}>
          <Col xs={24} md={16}>
            <Form
              ref={this.formRef} 
              name="control-ref" 
              layout={"vertical"} 
              
              initialValues={{
                link:"https://s.komdigi.go.id/"
              }}
            >
              <Button type="primary" onClick={this.downloadQRCode} >Download</Button>
              <Divider />
              <Form.Item
                label="Link"
                name="link"
              >
                <Input onChange={this.generateQR}/>
              </Form.Item>
            </Form>
            <QRCode 
              size={300}
              logoWidth={70}
              ecLevel={"H"}
              //qrStyle={'dots'}
              id={'qrCode'}
              logoImage={qr_logo}
              removeQrCodeBehindLogo={true}
              quietZone={5}
              eyeRadius={[
                  [20, 20, 0, 20], // top/left eye
                  [20, 20, 20, 0], // top/right eye
                  [20, 0, 20, 20], // bottom/left
              ]}
              value={this.state.link} />
          </Col>
        </Row>
      </>
    );
  };
}

export default QRCodeGenerator;
